import React from 'react';

import { MotifMefViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';
import { MotifMefFormValues } from 'types/referentiels/MotifMef';

import { buildRequestDto } from '../utils';

import ModalEditionMotifMef from './ModalEditionMotifMef';

interface ModalCreateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalCreate({
  close,
  visible,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: MotifMefFormValues = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: MotifMefFormValues) =>
      AdminFonctionnelControllerApi.createMotifMefUsingPOST(
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: MotifMefViolationDtoFormFieldEnum, values: MotifMefFormValues) =>
      AdminFonctionnelControllerApi.validateCreateMotifMefFieldUsingPOST(
        field,
        buildRequestDto(values),
      ),
    response => response.motifMefViolationsDto ?? [],
  );

  return (
    <ModalEditionMotifMef
      close={close}
      visible={visible}
      title="Créer un motif de MEF"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
